const getters = {
  isLoading: state => state.isLoading,
  consigneeTrack: state => state.consigneeTrack,
};

export default getters;
